<template>
    <b-tab lazy>
        <template #title>
            {{ $t('Measurement') }}
            <b-spinner v-if="pending" small />
        </template>

        <header class="d-flex mb-3 align-items-end">
            <div class="flex-grow-1 mr-3">
                <b-form-group
                    :label="$t('Search')"
                    class="mb-0"
                    for="filter-input"
                >
                    <b-input-group>
                        <b-form-input
                            id="filter-input"
                            v-model="filter"
                            :placeholder="$t('e.g. Wall 1 ...')"
                        />

                        <b-input-group-append>
                            <b-button :disabled="!filter" @click="filter = ''">
                                {{ $t('Clear') }}
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </div>
            <b-button
                :disabled="pending"
                class="ml-auto"
                @click="$refs.table.refresh()"
            >
                <fa :spin="pending" icon="sync" />
            </b-button>
        </header>

        <b-table
            ref="table"
            no-provider-sorting
            :api-url="apiUrl"
            :busy.sync="pending"
            :fields="fields"
            :items="fetchData"
            :filter="filter"
        >
            <template #cell(sing_and_factor)="{item}">
                {{ item.factor_sign }} {{ (item.factor * 0.001).toLocaleString($i18n.locale, {format: 'number'}) }}
            </template>
        </b-table>
    </b-tab>
</template>

<script>
    import fetchTableData from "@/mixins/fetchTableData";

    export default {
        name: "Measurement",
        mixins: [fetchTableData],
        props: {
            apiUrl: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                pending: false,
                filter: null,
                items:[],
                fields: [
                    {
                        key: 'name',
                        label: this.$t('Name'),
                        sortable: true,
                        variant: 'secondary',
                    },
                    {
                        key: 'ordinal',
                        label: this.$t('Ordinal'),
                        sortable: true
                    },
                    {
                        key: 'explanation',
                        label: this.$t('Explanation'),
                        sortable: true
                    },
                    {
                        key: 'sing_and_factor',
                        label: this.$t('Factor'),
                        sortable: true
                    },
                    {
                        key: 'formula_number',
                        label: this.$t('Formula number'),
                        sortable: true
                    },
                    {
                        key: 'values',
                        label: this.$t('Formula'),
                        sortable: true
                    },
                    {
                        key: 'location',
                        label: this.$t('Location'),
                        sortable: true
                    },
                ]
            }
        },
    }
</script>
